// Grace companions (practice-loop-v2). Hardcoded const per the N=3 rule —
// no DB table, no registry. `packAffinity` is the future pack-specific slot
// (common-ground D2): v0.2 leaves every entry undefined = globally available.
// Passives are presentation-layer only (grace principle): they modulate
// celebrations and comfort, never XP / unlock / SRS / daily streak.

import { z } from 'zod'
import type { PackId } from './packs.ts'

export const COMPANION_IDS = ['sparrow', 'eagle', 'donkey'] as const
export const companionIdSchema = z.enum(COMPANION_IDS)
export type CompanionId = z.infer<typeof companionIdSchema>

export interface Companion {
  id: CompanionId
  nameZh: string
  nameEn: string
  /** One-line passive copy for the selection card. */
  passiveZh: string
  /** Short verse quote (selection card small print). */
  verseZh: string
  scriptureRef: string
  /** Future pack-specific expansion slot — v0.2: always undefined. */
  packAffinity?: PackId
  /** Static asset paths (Pages serves /assets/*). */
  cardUrl: string
  avatarUrl: string
}

export const COMPANIONS: readonly Companion[] = [
  {
    id: 'sparrow',
    nameZh: '麻雀',
    nameEn: 'Sparrow',
    passiveZh: '每場第一次答錯，連對不中斷',
    verseZh: '你們比許多麻雀還貴重',
    scriptureRef: '太 10:29-31',
    cardUrl: '/assets/companions/sparrow-card.jpg',
    avatarUrl: '/assets/companions/sparrow-avatar.png',
  },
  {
    id: 'eagle',
    nameZh: '鷹',
    nameEn: 'Eagle',
    passiveZh: '補做的題目答對時，一起翱翔慶祝',
    verseZh: '如鷹展翅上騰',
    scriptureRef: '賽 40:31',
    cardUrl: '/assets/companions/eagle-card.jpg',
    avatarUrl: '/assets/companions/eagle-avatar.png',
  },
  {
    id: 'donkey',
    nameZh: '小驢駒',
    nameEn: 'Donkey Colt',
    passiveZh: '連對的慶祝更盛大',
    verseZh: '和散那！奉主名來的是應當稱頌的',
    scriptureRef: '太 21:7-9',
    cardUrl: '/assets/companions/donkey-card.jpg',
    avatarUrl: '/assets/companions/donkey-avatar.png',
  },
]

export function companionById(id: CompanionId): Companion {
  const found = COMPANIONS.find((c) => c.id === id)
  if (!found) throw new Error(`unknown companion: ${id}`)
  return found
}

/** Body for PATCH /api/me/companion. Strict — server-side request parse. */
export const companionPatchRequestSchema = z
  .object({ companionId: companionIdSchema })
  .strict()
export type CompanionPatchRequest = z.infer<typeof companionPatchRequestSchema>
